/**
 * ChevronDownIcon — sanitized from `assets/newSvg/chevron-down.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function ChevronDownIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M13.0607,16.0607 C12.4749,16.6465 11.5251,16.6465 10.9393,16.0607 L5.28249,10.4038 C4.6967,9.81804 4.6967,8.86829 5.28248,8.2825 C5.86827,7.69672 6.81802,7.69672 7.40381,8.2825 L12,12.8787 L16.5962,8.2825 C17.182,7.69672 18.1317,7.69672 18.7175,8.2825 C19.3033,8.86829 19.3033,9.81804 18.7175,10.4038 L13.0607,16.0607 Z"
        fill={color}
      />
    </Svg>
  );
}

export default ChevronDownIcon;
